import { useEffect } from 'react';

interface LedgerListKeyHandlers {
  enabled: boolean;
  onDown: () => void;
  onUp: () => void;
  onPeek: () => void;
  onClose: () => void;
}

export function useLedgerListKeys({ enabled, onDown, onUp, onPeek, onClose }: LedgerListKeyHandlers): void {
  useEffect(() => {
    if (!enabled) return undefined;
    const handler = (event: KeyboardEvent) => {
      const target = event.target as HTMLElement | null;
      if (
        target &&
        (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable)
      ) {
        return;
      }
      // A select/popup (or any interactive control) already handled this key —
      // don't let its Enter/Escape leak into the list's navigation model.
      if (event.defaultPrevented) return;
      if (target?.closest('button, a, [role="listbox"], [role="option"], [role="menu"], [role="menuitem"], [role="dialog"]')) return;
      if (event.metaKey || event.ctrlKey || event.altKey) return;
      if (event.key === 'j') onDown();
      else if (event.key === 'k') onUp();
      else if (event.key === 'Enter') onPeek();
      else if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [enabled, onDown, onUp, onPeek, onClose]);
}
